export const setSpecialEvents = specialevents => ({
    type: 'SPECIAL_EVENTS',
    payload: specialevents
});

export default setSpecialEvents;